import { AST } from '@handlebars/parser';
import { isNull } from 'utils/tsHelpers';

export const getMergeTagMustacheStatement = (mustacheStatement: AST.MustacheStatement | null) =>
  !isNull(mustacheStatement) &&
  !mustacheStatement.hash?.pairs.length && // Merge tags must not have any hash pairs
  !mustacheStatement.params.length // Merge tags must not have any params
    ? mustacheStatement
    : null;
